<template>
  <div
    class="col step"
    :class="{
      [currentStage]: currentStage,
      active: step.isActive
    }"
  >
    <div
      class="row"
    >
      <div class="col-9">
        <div
          class="circle rounded-circle row align-items-center justify-content-center"
          @click="selectedStep"
        >
          <div class="text col-12">
            <slot>
              <label class="text-center d-block w-100">{{ step.label }}</label>
              <span class="status text-center d-block w-100">{{ currentStatusText }}</span>
            </slot>
          </div>
        </div>
      </div>
      <div
        v-if="step.action > -1"
        class="col-3"
      >
        <div class="step_divider row align-items-center">
          <div class="col-12 p-0">
            <div class="divider" />
            <div class="triangle" />
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
const INACTIVE = 0
const COMPLETED = 1
const NOT_PURCHASED = 2
const DISABLED = 3
const ENROLL = 0
const PURCHASE = 1
export default {
  name: 'LarStep',
  props: {
    step: {
      type: Object,
      required: true
    }
  },
  data () {
    return {
      stageText: ['尚未確認', '已確認', '已確認不', ''],
      actionText: ['報名', '購買'],
      stages: ['', 'completed', 'not_purchased', 'disabled']
    }
  },
  computed: {
    currentStatusText () {
      if (this.step.stage === DISABLED) {
        return ''
      }
      return `${this.stageText[this.step.stage]}${this.actionText[this.step.action]}`
    },
    currentStage () {
      return this.stages[this.step.stage]
    }
  },
  methods: {
    selectedStep () {
      if (this.currentStage !== 'disabled') {
        this.$emit('step:clicked', this.step)
      }
    }
  }
}
</script>
